import { LOCALE_ID, Provider } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_LANGUAGE_CODE, isLanguageCode } from './localization.utils';

export class LocaleId extends String {
  constructor(private _translateService: TranslateService) {
    super();
  }

  public override toString(): string {
    const localeId = this._translateService.currentLang;
    return isLanguageCode(localeId) ? localeId : DEFAULT_LANGUAGE_CODE;
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const LocaleProvider: Provider = {
  provide: LOCALE_ID,
  useClass: LocaleId,
  deps: [TranslateService],
};
